import SearchBar from "./search_bar"
import SearchResults from "./search_results"

const run = () => {
  SearchBar.listen()
  if (window.location.href.includes("/search/articles"))
    SearchResults.run()
}

export default Object.freeze({ run })